import React, { Component } from 'react';
import { FloatLabel } from '../../Components';
import { WidgetHelper } from '../WidgetHelper';
import Select from 'react-select';
import {
    Dictionary,
    ISubscribeEvent,
    IActirisError,
    IEventDate,
} from '../../Models';
import { EventService } from '../../Services';
import { IEventOtherDate } from '../../Models/Event/IEventOtherDate';

interface ISubscribeEventFormWidgetProps {
    dictSubscribe: string;
    id: string | null;
    dictFirstName: string;
    dictLastName: string;
    dictEmail: string;
    dictPhone: string;
    dictLanguage: string;
    dictSend: string;
    dictErrorSubscribe: string;
    dictSuccessSubscribe: string;
    dictAlreadySubscribe: string;
    dictEventSubscribeClose: string;
    dictMaxDateSubscribeInThePast: string;
    dictClose: string;
    handleCloseModalSubscribe: () => void | null;
    dictDate?: string;
    dictNiss: string;
    dictLiveInBrussels: string;
    dictActirisSubscribe: string;
    dictNotActirisSubscribe: string;
    dictEventFullSubscribers?: string;
    dictEventInThePast?: string;
    dictNotFirstnameFill: string;
    dictNotLastnameFill: string;
    dictNotEmailFill: string;
    dictNotNissFill: string;
    dictNotLanguageFill: string;
    dictNotEventFill?: string;
    dictGdrpSentences: string;
    dictGdrpLink: string;
    dictEventFull: string;
    linkGdpr: string;
    dictNoGdprFill: string;
    dictNotPhoneFill: string;
    category?: string;
    pageTitle?: string;
    isNissRequired: boolean;
    otherDates: IEventOtherDate[];
}

interface ISubscribeEventFormWidgetState {
    showModalSubscribe: boolean;
    languageDictionary: Dictionary<number, string>[] | null;
    subscribe: ISubscribeEvent;
    errorSubscribe: string | null;
    subscribeSuccess: boolean;
    eventList: IEventDate[] | null;
    isFormFullFill: boolean;
    isLivingBrusselsAndSubscribe: boolean;
    eventIsFullSubscriber: boolean;
    eventInThePast: boolean;
    eventSubscriptionClosed: boolean;
    gdprSelected: boolean;
    selectedDateState: IEventDate | null;
    selectedOtherDateState: { value: IEventOtherDate; label: string } | null;
}

export class SubscribeEventFormWidget extends Component<
    ISubscribeEventFormWidgetProps,
    ISubscribeEventFormWidgetState
> {
    languageList: Dictionary<number, string>[] = [
        { value: 1, label: 'FR' },
        { value: 2, label: 'NL' },
    ];

    selectedLanguage: Dictionary<number, string> = { value: 1, label: 'FR' };

    isLivingBrussels: boolean = false;
    isActirisSubscribe: boolean = false;
    isMailFill: boolean = true;
    isPhoneFill: boolean = true;
    isFirstnameFill: boolean = true;
    isLastnameFill: boolean = true;
    isLanguageFill: boolean = true;
    isNissFill: boolean = true;
    isIdEventFill: boolean = true;
    isGdprSelected: boolean = true;

    categoryForNissFr: string = "Séances d'inscriptions collectives";
    categoryForNissNl: string = 'Collectieve inschrijvingsessies';

    constructor(props: ISubscribeEventFormWidgetProps) {
        super(props);

        this.state = {
            showModalSubscribe: false,
            languageDictionary: this.languageList,
            subscribe: {
                email: '',
                firstName: '',
                idEvent: this.props.id ? +this.props.id : null,
                language: 'Fr',
                lastName: '',
                niss: '',
                phone: '',
                source: this.props.id ? 1 : 5,
                captchaToken: '',
            },
            errorSubscribe: null,
            subscribeSuccess: false,
            eventList: null,
            isFormFullFill: true,
            isLivingBrusselsAndSubscribe: true,
            eventIsFullSubscriber: false,
            eventInThePast: false,
            eventSubscriptionClosed: false,
            gdprSelected: false,
            selectedDateState: null,
            selectedOtherDateState: null,
        };
    }

    getAllEventInfoServiceAnimation = async () => {
        try {
            const eventList = await EventService.getAllInfoServiceAnimation(25);
            this.setState({
                eventList,
                isFormFullFill: true,
            });
        } catch (e) {
            if (!(e instanceof DOMException) || e.name !== 'AbortError') {
                throw e;
            }
        }
    };

    componentDidMount(): void {
        if (!this.props.id) {
            void this.getAllEventInfoServiceAnimation();
        }
    }

    componentDidUpdate(
        prevProps: ISubscribeEventFormWidgetProps,
        prevState: ISubscribeEventFormWidgetState
    ) {
        if (prevProps.otherDates !== this.props.otherDates) {
            if (
                this.props.otherDates &&
                this.props.otherDates.length > 0 &&
                !this.state.selectedOtherDateState
            ) {
                const firstOption = {
                    value: this.props.otherDates[0],
                    label: (this.props.otherDates[0].StartDate as Date)
                        .toLocaleString()
                        .replace(', 00:00:00', ''),
                };
                this.onSelectOtherDate(firstOption);
            }
        }

        if (
            !prevState.subscribeSuccess &&
            this.state.subscribeSuccess &&
            this.props.pageTitle
        ) {
            const fbq = document.createElement('script');
            fbq.innerHTML = "fbq('trackCustom', 'ActirisVDAB-Subscribe-Ok');";
            document.body.appendChild(fbq);

            const script = document.createElement('script');
            script.innerHTML =
                "gtag('event', 'conversion', {'allow_custom_scripts': true, 'send_to': 'DC-8765843/invmedia/actir0+unique'});";
            document.body.appendChild(script);

            const scriptYoutube = document.createElement('script');
            scriptYoutube.innerHTML =
                "gtag('event', 'conversion', {'send_to': 'AW-432646851/AFlDCJ3m8vcBEMPVps4B'});";
            document.head.appendChild(scriptYoutube);
        }
    }

    handleCloseModalSubscribe = () => {
        this.props.handleCloseModalSubscribe();
    };

    onSelectLanguage = (option: Dictionary<number, string>) => {
        this.selectedLanguage = option;
        this.setState((prevState) => ({
            subscribe: { ...prevState.subscribe, language: option.label },
        }));
    };

    handleFirstNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        this.setState((prevState) => ({
            subscribe: { ...prevState.subscribe, firstName: value },
        }));
    };

    handleLastNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        this.setState((prevState) => ({
            subscribe: { ...prevState.subscribe, lastName: value },
        }));
    };

    handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        this.setState((prevState) => ({
            subscribe: { ...prevState.subscribe, email: value },
        }));
    };

    handlePhoneChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        this.setState((prevState) => ({
            subscribe: { ...prevState.subscribe, phone: value },
        }));
    };

    handleNissChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let value = event.target.value;

        if (value.length > event.target.maxLength) {
            value = value.slice(0, event.target.maxLength);
        }

        value = value.replace(/[^\d.-]/g, '');

        this.setState((prev) => ({
            subscribe: { ...prev.subscribe, niss: value },
        }));
    };

    onSelectOtherDate = (option: { value: IEventOtherDate; label: string }) => {
        this.setState((prevState) => ({
            subscribe: {
                ...prevState.subscribe,
                idEvent: option.value.EventId,
            },
            selectedOtherDateState: option,
            eventIsFullSubscriber:
                option.value.NbrRegistered !== null
                    ? option.value.NbrRegistered >= option.value.Places
                    : false,
            eventInThePast: this.checkInThePast(
                new Date(option.value.StartDate)
            ),
            eventSubscriptionClosed: this.checkInThePast(
                new Date(option.value.MaxDateSubscribe)
            ),
        }));
    };

    onSelectDate = (option: IEventDate) => {
        this.setState((prevState) => ({
            subscribe: {
                ...prevState.subscribe,
                idEvent: option.value,
            },
            selectedDateState: option,
            eventIsFullSubscriber: option.subscribeCount >= option.maxSubscribe,
            eventInThePast: this.checkInThePast(new Date(option.date)),
        }));
    };

    checkInThePast(date: Date): boolean {
        const now = new Date();
        const hasTime = date.getHours() !== 0 || date.getMinutes() !== 0;

        if (hasTime) {
            return now >= date;
        } else {
            const today = new Date(
                now.getFullYear(),
                now.getMonth(),
                now.getDate()
            );
            const eventDay = new Date(
                date.getFullYear(),
                date.getMonth(),
                date.getDate()
            );
            return today > eventDay;
        }
    }

    onClickLivingInBrussels = () => {
        this.isLivingBrussels = !this.isLivingBrussels;
    };

    onClickActirisSubscribe = () => {
        this.isActirisSubscribe = !this.isActirisSubscribe;
    };

    checkFormFullFill = (): boolean => {
        this.clearValidation();
        let isFullFill: boolean = true;

        if (!this.state.subscribe.email) {
            this.isMailFill = false;
            isFullFill = false;
        }
        if (!this.props.id && !this.state.subscribe.phone) {
            this.isPhoneFill = false;
            isFullFill = false;
        }
        if (!this.state.subscribe.firstName) {
            this.isFirstnameFill = false;
            isFullFill = false;
        }
        if (!this.state.subscribe.idEvent) {
            this.isIdEventFill = false;
            isFullFill = false;
        }
        if (!this.state.subscribe.language) {
            this.isLanguageFill = false;
            isFullFill = false;
        }
        if (!this.state.subscribe.lastName) {
            this.isLastnameFill = false;
            isFullFill = false;
        }

        if (
            (this.props.category &&
                (this.props.category === this.categoryForNissFr ||
                    this.props.category === this.categoryForNissNl)) ||
            !this.props.id
        ) {
            if (!this.state.subscribe.niss || !this.validateNiss()) {
                this.isNissFill = false;
                isFullFill = false;
            }
        }

        if (!this.state.gdprSelected) {
            this.isGdprSelected = false;
            isFullFill = false;
        }

        return isFullFill;
    };

    validateNiss = (): boolean => {
        const niss = this.state.subscribe.niss.replace(/\D/g, '');

        if (!niss || !/^\d{11}$/.test(niss)) {
            return false;
        }

        const date = niss.slice(0, 6);
        const to_control = niss.slice(0, 9);
        const control = niss.slice(9, 11);

        const dateYear = parseInt(date.slice(0, 2), 10);
        let dateMonth = parseInt(date.slice(2, 4), 10);
        const dateDay = parseInt(date.slice(4, 6), 10);

        const todayYear = parseInt(
            new Date().getFullYear().toString().slice(2, 4),
            10
        );

        if (dateMonth >= 21 && dateMonth <= 32) {
            dateMonth -= 20;
        } else if (dateMonth >= 41 && dateMonth <= 52) {
            dateMonth -= 40;
        }

        if (
            (dateMonth !== 0 && (dateMonth < 1 || dateMonth > 12)) ||
            (dateDay !== 0 && (dateDay < 1 || dateDay > 31))
        ) {
            return false;
        }

        const fullYear =
            dateYear <= todayYear ? 2000 + dateYear : 1900 + dateYear;

        let toControlNumber = parseInt(to_control, 10);
        if (fullYear >= 2000) {
            toControlNumber += 2000000000;
        }

        const modulo = 97 - (toControlNumber % 97);
        const moduloNumber = modulo < 10 ? '0' + modulo : '' + modulo;

        return control === moduloNumber;
    };

    handleGdprChange = () => {
        this.setState((prev) => ({ gdprSelected: !prev.gdprSelected }));
    };

    clearValidation = () => {
        this.setState({ errorSubscribe: '' });

        this.isMailFill = true;
        this.isFirstnameFill = true;
        this.isIdEventFill = true;
        this.isLanguageFill = true;
        this.isLastnameFill = true;
        this.isNissFill = true;
        this.isGdprSelected = true;
        this.isPhoneFill = true;
    };

    isLivingInBrusselsAndSubscribe = (): boolean => {
        if (this.props.dictDate && !this.props.id) {
            return this.isActirisSubscribe && this.isLivingBrussels;
        }
        return this.isLivingBrussels && this.isActirisSubscribe;
    };

    submitForm = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const captchaInput =
            event.currentTarget.querySelector<HTMLInputElement>(
                'input[type="hidden"][name="captchaToken"]'
            );
        const captchaToken = captchaInput ? captchaInput.value : '';

        const formIsValid = this.checkFormFullFill();
        const livingValid = this.isLivingInBrusselsAndSubscribe();

        if (formIsValid && livingValid) {
            try {
                const cleanedSubscribe = {
                    ...this.state.subscribe,
                    captchaToken,
                    niss: this.state.subscribe.niss
                        ? this.state.subscribe.niss.replace(/\D/g, '')
                        : '',
                };

                const response: IActirisError[] =
                    await EventService.subscribeEvent(cleanedSubscribe);
                if (!response || response.length < 1) {
                    this.setState({ subscribeSuccess: true });
                } else if (response[0].code === 'RegistrationClosed') {
                    this.setState({
                        errorSubscribe: this.props.dictEventSubscribeClose,
                    });
                } else if (response[0].code === 'AlreadyRegistered') {
                    this.setState({
                        errorSubscribe: this.props.dictAlreadySubscribe,
                    });
                } else {
                    this.setState({
                        errorSubscribe: this.props.dictErrorSubscribe,
                    });
                }
            } catch (e) {
                if (!(e instanceof DOMException) || e.name !== 'AbortError') {
                    throw e;
                }
            }
        } else {
            if (!livingValid) {
                this.setState({ isLivingBrusselsAndSubscribe: false });
            }
            if (!formIsValid) {
                this.setState({ isFormFullFill: false });
            }
        }
    };

    render() {
        const selectDateOptions: { value: IEventOtherDate; label: string }[] =
            this.props.otherDates && this.props.otherDates.length > 0
                ? this.props.otherDates.map((oD) => ({
                      value: oD,
                      label: (oD.StartDate as Date)
                          .toLocaleString()
                          .replace(', 00:00:00', ''),
                  }))
                : [];

        if (
            this.state.subscribeSuccess ||
            (this.state.errorSubscribe &&
                this.state.errorSubscribe === 'DejaInscrit')
        ) {
            return (
                <>
                    {this.props.pageTitle && (
                        <noscript>
                            <img
                                src="https://urldefense.proofpoint.com/v2/url?u=https-3A__ad.doubleclick.net_ddm_activity_src-3D8765843-3Btype-3Dinvmedia-3Bcat-3Dactir0-3Bdc-5Flat-3D-3Bdc-5Frdid-3D-3Btag-5Ffor-5Fchild-5Fdirected-5Ftreatment-3D-3Btfua-3D-3Bnpa-3D-3Bgdpr-3D-24-257BGDPR-257D-3Bgdpr-5Fconsent-3D-24-257BGDPR-5FCONSENT-5F755-257D-3Bord-3D1-3Bnum-3D1-3F&d=DwIGaQ&c=4JOzdpIlQcN5fHQL_PMhCQ&r=MF_iaLXDXrDU2vlHZtM64-06_Pkp9OLARXOksVLPcQY&m=yWv90HVGrv1hs2BQxJmeqjKzlpPAQX209aWWZd6uiUg&s=GfFn33nq1yDN8rDjHnOOeU_kea_kksQPKMTCluiOuK0&e= "
                                width="1"
                                height="1"
                                alt=""
                            />
                        </noscript>
                    )}

                    <h2>{this.props.dictSubscribe}</h2>
                    <div
                        className="alert alert-success alert-dismissible fade show"
                        role="alert"
                    >
                        {this.props.dictSuccessSubscribe}
                        <button
                            type="button"
                            className="close"
                            data-dismiss="alert"
                            aria-label="Close"
                        >
                            <i className="icon-cross"></i>
                        </button>
                    </div>
                </>
            );
        }
        return (
            <>
                <form
                    onSubmit={(e) => {
                        void this.submitForm(e);
                    }}
                >
                    <h2>{this.props.dictSubscribe}</h2>
                    {this.state.errorSubscribe &&
                        this.state.errorSubscribe !== 'DejaInscrit' && (
                            <div
                                className="alert alert-danger alert-dismissible fade show"
                                role="alert"
                            >
                                {this.state.errorSubscribe}
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="alert"
                                    aria-label="Close"
                                >
                                    <i className="icon-cross"></i>
                                </button>
                            </div>
                        )}
                    {!this.state.eventList && !this.props.id && (
                        <div className="lds-ripple">
                            <div></div>
                            <div></div>
                        </div>
                    )}
                    {(this.state.eventList || this.props.id) && (
                        <>
                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <div className="form-group">
                                        <FloatLabel
                                            active={true}
                                            label={
                                                this.props.dictFirstName + ' *'
                                            }
                                            labelId={'firstname'}
                                        >
                                            <input
                                                title="firstname"
                                                type="text"
                                                placeholder={
                                                    this.props.dictFirstName
                                                }
                                                value={
                                                    this.state.subscribe
                                                        .firstName
                                                        ? this.state.subscribe
                                                              .firstName
                                                        : ''
                                                }
                                                onChange={
                                                    this.handleFirstNameChange
                                                }
                                            />
                                        </FloatLabel>
                                    </div>
                                    {!this.isFirstnameFill && (
                                        <div
                                            className="alert alert-danger alert-dismissible fade show"
                                            role="alert"
                                        >
                                            {this.props.dictNotFirstnameFill}
                                        </div>
                                    )}
                                </div>
                                <div className="col-12 col-lg-6">
                                    <div className="form-group">
                                        <FloatLabel
                                            active={true}
                                            label={
                                                this.props.dictLastName + ' *'
                                            }
                                            labelId={'name'}
                                        >
                                            <input
                                                title="name"
                                                type="text"
                                                placeholder={
                                                    this.props.dictLastName
                                                }
                                                value={
                                                    this.state.subscribe
                                                        .lastName
                                                        ? this.state.subscribe
                                                              .lastName
                                                        : ''
                                                }
                                                onChange={
                                                    this.handleLastNameChange
                                                }
                                            />
                                        </FloatLabel>
                                    </div>
                                    {!this.isLastnameFill && (
                                        <div
                                            className="alert alert-danger alert-dismissible fade show"
                                            role="alert"
                                        >
                                            {this.props.dictNotLastnameFill}
                                        </div>
                                    )}
                                </div>
                                <div className="col-12 col-lg-6">
                                    <div className="form-group">
                                        <FloatLabel
                                            active={true}
                                            label={this.props.dictEmail + ' *'}
                                            labelId={'email'}
                                        >
                                            <input
                                                title="email"
                                                type="email"
                                                placeholder={
                                                    this.props.dictEmail
                                                }
                                                value={
                                                    this.state.subscribe.email
                                                        ? this.state.subscribe
                                                              .email
                                                        : ''
                                                }
                                                onChange={
                                                    this.handleEmailChange
                                                }
                                            />
                                        </FloatLabel>
                                    </div>
                                    {!this.isMailFill && (
                                        <div
                                            className="alert alert-danger alert-dismissible fade show"
                                            role="alert"
                                        >
                                            {this.props.dictNotEmailFill}
                                        </div>
                                    )}
                                </div>
                                <div className="col-12 col-lg-6">
                                    <div className="form-group">
                                        {!this.props.id && (
                                            <FloatLabel
                                                active={true}
                                                label={
                                                    this.props.dictPhone + ' *'
                                                }
                                                labelId={'phone'}
                                            >
                                                <input
                                                    title="phone"
                                                    type="text"
                                                    placeholder={
                                                        this.props.dictPhone
                                                    }
                                                    value={
                                                        this.state.subscribe
                                                            .phone
                                                            ? this.state
                                                                  .subscribe
                                                                  .phone
                                                            : ''
                                                    }
                                                    onChange={
                                                        this.handlePhoneChange
                                                    }
                                                />
                                            </FloatLabel>
                                        )}
                                        {this.props.id && (
                                            <FloatLabel
                                                active={true}
                                                label={this.props.dictPhone}
                                                labelId={'phone'}
                                            >
                                                <input
                                                    title="phone"
                                                    type="text"
                                                    placeholder={
                                                        this.props.dictPhone
                                                    }
                                                    value={
                                                        this.state.subscribe
                                                            .phone
                                                            ? this.state
                                                                  .subscribe
                                                                  .phone
                                                            : ''
                                                    }
                                                    onChange={
                                                        this.handlePhoneChange
                                                    }
                                                />
                                            </FloatLabel>
                                        )}
                                    </div>
                                    {!this.isPhoneFill && (
                                        <div
                                            className="alert alert-danger alert-dismissible fade show"
                                            role="alert"
                                        >
                                            {this.props.dictNotPhoneFill}
                                        </div>
                                    )}
                                </div>
                                {(this.props.isNissRequired ||
                                    (this.props.category &&
                                        this.props.category ===
                                            this.categoryForNissFr) ||
                                    this.props.category ===
                                        this.categoryForNissNl ||
                                    !this.props.id) && (
                                    <div className="col-12 col-lg-6">
                                        <div className="form-group">
                                            <FloatLabel
                                                active={true}
                                                label={
                                                    this.props.dictNiss + ' *'
                                                }
                                                labelId={'niss'}
                                            >
                                                {/* FIX — type="text" au lieu de type="number" :
                                                    maxLength ne fonctionne pas sur type="number"
                                                    et les séparateurs (.-) sont nécessaires pour validateNiss */}
                                                <input
                                                    title="niss"
                                                    type="text"
                                                    maxLength={15}
                                                    placeholder={
                                                        this.props.dictNiss
                                                    }
                                                    value={
                                                        this.state.subscribe
                                                            .niss
                                                            ? this.state
                                                                  .subscribe
                                                                  .niss
                                                            : ''
                                                    }
                                                    onChange={
                                                        this.handleNissChange
                                                    }
                                                />
                                            </FloatLabel>
                                        </div>
                                        {!this.isNissFill && (
                                            <div
                                                className="alert alert-danger alert-dismissible fade show"
                                                role="alert"
                                            >
                                                {this.props.dictNotNissFill}
                                            </div>
                                        )}
                                    </div>
                                )}
                                <div className="col-12">
                                    <div className="form-group">
                                        <FloatLabel
                                            active={true}
                                            label={
                                                this.props.dictLanguage + ' *'
                                            }
                                            labelId="language"
                                        >
                                            <Select
                                                aria-labelledby="language"
                                                placeholder={
                                                    this.props.dictLanguage
                                                }
                                                value={this.selectedLanguage}
                                                options={
                                                    this.state
                                                        .languageDictionary ??
                                                    []
                                                }
                                                onChange={this.onSelectLanguage}
                                                className="filter-select-container"
                                                classNamePrefix="filter-select"
                                                closeMenuOnSelect={true}
                                                hideSelectedOptions={false}
                                            />
                                        </FloatLabel>
                                    </div>
                                    {!this.isLanguageFill && (
                                        <div
                                            className="alert alert-danger alert-dismissible fade show"
                                            role="alert"
                                        >
                                            {this.props.dictNotLanguageFill}
                                        </div>
                                    )}
                                </div>
                                {this.props.dictDate && !this.props.id && (
                                    <>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <FloatLabel
                                                    active={true}
                                                    label={
                                                        this.props.dictDate +
                                                        ' *'
                                                    }
                                                    labelId="Date"
                                                >
                                                    <Select
                                                        aria-labelledby="Date"
                                                        placeholder={
                                                            this.props.dictDate
                                                        }
                                                        value={
                                                            this.state
                                                                .selectedDateState
                                                        }
                                                        options={this.state.eventList?.map(
                                                            (e) => ({
                                                                ...e,
                                                                value: e.idEvent,
                                                                label: `${e.date} – ${e.title}`,
                                                            })
                                                        )}
                                                        onChange={
                                                            this.onSelectDate
                                                        }
                                                        className="filter-select-container"
                                                        classNamePrefix="filter-select"
                                                        closeMenuOnSelect={true}
                                                        hideSelectedOptions={
                                                            false
                                                        }
                                                    />
                                                </FloatLabel>
                                            </div>
                                            {!this.isIdEventFill && (
                                                <div
                                                    className="alert alert-danger alert-dismissible fade show"
                                                    role="alert"
                                                >
                                                    {
                                                        this.props
                                                            .dictNotEventFill
                                                    }
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}
                                {this.props.otherDates &&
                                    selectDateOptions.length !== 0 && (
                                        <div className="col-12">
                                            <div className="form-group">
                                                <FloatLabel
                                                    active={true}
                                                    label={
                                                        this.props.dictDate +
                                                        ' *'
                                                    }
                                                    labelId="Date"
                                                >
                                                    <Select
                                                        aria-labelledby="StartDate"
                                                        options={
                                                            selectDateOptions
                                                        }
                                                        value={
                                                            this.state
                                                                .selectedOtherDateState
                                                        }
                                                        onChange={
                                                            this
                                                                .onSelectOtherDate
                                                        }
                                                        className="filter-select-container"
                                                        classNamePrefix="filter-select"
                                                        closeMenuOnSelect={true}
                                                        hideSelectedOptions={
                                                            false
                                                        }
                                                    />
                                                </FloatLabel>
                                            </div>
                                            {!this.isIdEventFill && (
                                                <div
                                                    className="alert alert-danger alert-dismissible fade show"
                                                    role="alert"
                                                >
                                                    {this.props.dictEventFull}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                <div className="col-12">
                                    <div className="form-group">
                                        <div className="form-group switch">
                                            <input
                                                type="checkbox"
                                                id="switchLiving"
                                                defaultChecked={false}
                                                onClick={
                                                    this.onClickLivingInBrussels
                                                }
                                            />
                                            <label htmlFor="switchLiving">
                                                {this.props.dictLiveInBrussels}{' '}
                                                *
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <div className="form-group switch">
                                            <input
                                                type="checkbox"
                                                id="switchSubscribe"
                                                defaultChecked={false}
                                                onClick={
                                                    this.onClickActirisSubscribe
                                                }
                                            />
                                            <label htmlFor="switchSubscribe">
                                                {
                                                    this.props
                                                        .dictActirisSubscribe
                                                }{' '}
                                                *
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                {!this.state.isLivingBrusselsAndSubscribe && (
                                    <div
                                        className="alert alert-danger alert-dismissible fade show"
                                        role="alert"
                                    >
                                        {this.props.dictNotActirisSubscribe}
                                    </div>
                                )}
                            </div>
                            <div className="col-12">
                                <div className="form-group form-group-checkbox consent">
                                    <input
                                        type="checkbox"
                                        id="checkbox"
                                        onChange={this.handleGdprChange}
                                    />
                                    <label htmlFor="checkbox">
                                        {this.props.dictGdrpSentences}{' '}
                                        <a
                                            href={this.props.linkGdpr}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {this.props.dictGdrpLink}
                                        </a>
                                    </label>
                                </div>
                                {!this.isGdprSelected && (
                                    <div
                                        className="alert alert-danger alert-dismissible fade show"
                                        role="alert"
                                    >
                                        {this.props.dictNoGdprFill}
                                    </div>
                                )}
                            </div>
                            {!this.state.eventIsFullSubscriber &&
                                !this.state.eventInThePast &&
                                !this.state.eventSubscriptionClosed &&
                                this.props.pageTitle && (
                                    <button
                                        className="form-submit gtm-forms"
                                        type="submit"
                                        data-gtmFormTitle={this.props.pageTitle}
                                    >
                                        {this.props.dictSend}
                                    </button>
                                )}
                            {!this.state.eventIsFullSubscriber &&
                                !this.state.eventInThePast &&
                                !this.state.eventSubscriptionClosed &&
                                !this.props.pageTitle && (
                                    <button
                                        className="form-submit"
                                        type="submit"
                                    >
                                        {this.props.dictSend}
                                    </button>
                                )}
                            {this.state.eventIsFullSubscriber && (
                                <div
                                    className="alert alert-danger alert-dismissible fade show"
                                    role="alert"
                                >
                                    {this.props.dictEventFullSubscribers}
                                </div>
                            )}
                            {this.state.eventInThePast && (
                                <div
                                    className="alert alert-danger alert-dismissible fade show"
                                    role="alert"
                                >
                                    {this.props.dictEventInThePast}
                                </div>
                            )}
                            {this.state.eventSubscriptionClosed && (
                                <div
                                    className="alert alert-danger alert-dismissible fade show"
                                    role="alert"
                                >
                                    {this.props.dictMaxDateSubscribeInThePast}
                                </div>
                            )}
                        </>
                    )}
                </form>
            </>
        );
    }
}

WidgetHelper.register(SubscribeEventFormWidget, 'subscribe-event-form-widget');
